<template>
  <div :style="{'text-align':align}">
    <el-button
      @click="close"
      :loading="loading"
    >{{cancelText}}</el-button>
    <span style="width:10px;display:inline-block;"></span>
    <el-button
      type="primary"
      :disabled="confirmDisabled"
      :loading="loading"
      @click="confirm"
    >{{confirmText}}</el-button>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    align: {
      default: 'right',
    },
    cancelText: {
      default: '取消',
    },
    confirmText: {
      default: '确认',
    },
    confirmDisabled: {
      default: () => false,
    },
  },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    close() {
      this.$emit('onclose')
      this.$emit('update:visible', false)
    },
    confirm() {
      this.$emit('confirm', (bool = true) => {
        this.loading = bool
      })
    },
  },
}
</script>

<style lang="scss" scoped>
</style>